import { nanoIdSchema } from "../shared/id.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/task/waitTime.ts
const KNOWN_PRIORITIES = [
	0,
	500,
	1e3,
	1500,
	2e3
];
const isKnownPriority = (priority) => KNOWN_PRIORITIES.includes(priority);
const TaskWaitTimeDisplayBucket = {
	Under1Min: "under_1min",
	Minutes: "minutes",
	Over6h: "over_6h"
};
const waitTimePredictInputSchema = z.object({
	priority: z.coerce.number().int().refine(isKnownPriority, { message: "invalid priority" }),
	generationModelId: nanoIdSchema.optional(),
	modelVersionId: nanoIdSchema.optional()
}).refine((v) => v.modelVersionId != null || v.generationModelId != null, { message: "modelVersionId or generationModelId must be provided" });
const waitTimePredictOutputSchema = z.object({
	waitDurationSeconds: z.number(),
	displayBucket: z.enum([
		TaskWaitTimeDisplayBucket.Under1Min,
		TaskWaitTimeDisplayBucket.Minutes,
		TaskWaitTimeDisplayBucket.Over6h
	]),
	displayMinutes: z.int().nullable().optional()
});
const predictWaitTimeRoute = oc.route({
	summary: "Predict task wait time",
	description: "Returns an estimated wait time for a generation task of the given priority and target model. Provide either a generationModelId (latest version is resolved) or a modelVersionId (used directly, matching the enqueue generation task flow).",
	method: "GET",
	path: "/wait-time"
}).input(waitTimePredictInputSchema).output(waitTimePredictOutputSchema).errors({
	NOT_FOUND: {
		status: 404,
		message: "Wait time prediction not available"
	},
	BAD_REQUEST: {
		status: 400,
		message: "Invalid request"
	}
});
//#endregion
export { TaskWaitTimeDisplayBucket, predictWaitTimeRoute };
